import { Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { LoginComponent } from './pages/login/login.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { ProjectsComponent } from './pages/projects/overview/projects.component';
import { CompaniesOverviewComponent } from './pages/companies/companies-overview/companies-overview.component';
import { ProductsComponent } from './pages/products/overview/products.component';
import { ProductDetailComponent } from './pages/products/detail/product-detail.component';
import { TabsPlaceholderComponent } from './shared/tabs-placeholder/tabs-placeholder.component';
import { EditUserComponent } from './pages/users/edit-user/edit-user.component';
import { UsersOverviewComponent } from './pages/users/users-overview/users-overview.component';
import { EditCompanyComponent } from './pages/companies/edit/edit-company.component';
import { ContactsOverviewComponent } from './pages/contact/contacts-overview/contacts-overview.component';
import { EditContactComponent } from './pages/contact/edit-contact/edit-contact.component';
import { OngoingProjectsComponent } from './pages/projects/overview/client/ongoing-projects/ongoing-projects.component';
import { RepoProjectsComponent } from './pages/projects/overview/client/repo-projects/repo-projects.component';
import { CompletedProjectsComponent } from './pages/projects/overview/client/completed-projects/completed-projects.component';
import { AdminAuthGuardService } from './services/admin-auth-guard.service';
import { ClientCompanyGuardService } from './services/client-company-guard.service';
import { EmployeeUsersOverviewComponent } from './pages/users/users-overview/employee-users-overview/employee-users-overview.component';
import { CreateOldSystemProjectComponent } from './pages/projects/create-old-system-project/create-old-system-project.component';
import { AdminPlanningContainerComponent } from './pages/planning/admin-planning-container/admin-planning-container.component';
import { PlacerPlanningViewComponent } from './pages/planning/placer-planning-view/placer-planning-view.component';
import { ProjectPlacerFormComponent } from './pages/projects/placer/project-placer-form/project-placer-form.component';
import { NoAccessComponent } from './pages/no-access/no-access.component';
import { StockLocationsOverviewComponent } from './components/stock/locations/locations-overview.component';
import { SignsPortalComponent } from './components/stock/signs-portal/signs-portal.component';
import { SignsOverviewComponent } from './components/stock/signs/signs-overview.component';
import { SignEntryComponent } from './components/stock/signs/entry/sign-entry.component';
import { LoadTaskPlacerFormComponent } from './pages/projects/placer/load-task-placer-form/load-task-placer-form.component';
import { OtherTaskPlacerFormComponent } from './pages/projects/placer/other-task-placer-form/other-task-placer-form.component';
import { SignPlacementPriceDetailComponent } from './pages/products/detail/sign-placement-price/sign-placement-price-detail.component';
import { ImmoIpComponent } from './pages/immo-ip/immo-ip.component';
import { SignTitleAdjustmentPortalOverviewComponent } from './components/stock/signs-portal/signs-portal-association-overview/title/sign-title-adjustment-portal-overview.component';
import { SignPhoneNumberAdjustmentPortalOverviewComponent } from './components/stock/signs-portal/signs-portal-association-overview/phone/sign-phone-number-adjustment-portal-overview.component';
import { SignStickerPortalOverviewComponent } from './components/stock/signs-portal/signs-portal-association-overview/sticker/sign-sticker-portal-overview.component';
import { EditEmployeeUserComponent } from './pages/users/edit-employee-user/edit-employee-user.component';
import { ClientCornerMapComponent } from './pages/client-corner/client-corner-map/client-corner-map.component';
import { ClientCornerHomePageComponent } from './pages/client-corner/client-corner-home-page/client-corner-home-page.component';
import { ImmoIPPlacerTourViewComponent } from './pages/immo-ip/placer/tour-view/immo-ip-placer-tour-view.component';
import { ImmoIPPlacerTourItemDetailComponent } from './pages/immo-ip/placer/tour-item-detail/immo-ip-placer-tour-item-detail.component';
import { AtelierAssignmentsViewComponent } from './pages/atelier/atelier-assignments/atelier-assignments-view.component';
import { ImmoRedirectLandingPageComponent } from './pages/immo-ip/immo-redirect-landing-page/immo-redirect-landing-page.component';
import { SearchSubProjectsInputComponent } from './pages/search-subprojects/input/search-subprojects-input.component';
import { SearchSubProjectsResultComponent } from './pages/search-subprojects/result/search-subprojects-result.component';
import { CreateOldSystemImmoProjectComponent } from './pages/projects/create-old-system-immo-project/create-old-system-immo-project.component';
import { AtelierRecoveryComponent } from './pages/atelier/atelier-recovery/atelier-recovery.component';
import { RequestAccountComponent } from './pages/request-account/request-account.component';
import { ImmoIPPlacerImmoTaskDetailComponent } from './pages/immo-ip/placer/tour-item-detail/immo-task/immo-ip-placer-immo-task-detail.component';
import { AtelierSignComponent } from './pages/atelier/atelier-sign/atelier-sign.component';
import { ClientPortalConfigComponent } from './pages/configuration/client-portal-config/client-portal-config.component';
import { LoginRedirectGuard } from './services/login-redirect-guard.service';
import { AuthRedirectComponent } from './pages/auth/auth-redirect-component/auth-redirect.component';

export const ROUTES: Routes = [
  { path: '', component: AppComponent },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [LoginRedirectGuard],
  },
  {
    path: 'employee-login',
    component: LoginComponent,
    data: { shouldHandleVELogin: false },
  },
  {
    path: 'auth_redirect',
    component: AuthRedirectComponent,
  },
  { path: 'request-new-account', component: RequestAccountComponent },
  { path: 'request-account-recovery', component: ForgotPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'no-access', component: NoAccessComponent },
  {
    path: 'projecten',
    component: ProjectsComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: 'immo',
    component: ImmoIpComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: 'immo-redirect/:subProjectId',
    component: ImmoRedirectLandingPageComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: 'project/:projectId/:id',
    component: TabsPlaceholderComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: 'job/:projectId/:id',
    component: TabsPlaceholderComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: 'job/:projectId/:id/:fromImmo',
    component: TabsPlaceholderComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: 'create-old-system-project',
    component: CreateOldSystemProjectComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: 'create-old-system-immo-project',
    component: CreateOldSystemImmoProjectComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: 'admin-project/:projectId/:id',
    component: TabsPlaceholderComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: 'client-project/:projectId/:id',
    component: TabsPlaceholderComponent,
  },
  {
    path: 'client-job/:projectId/:id',
    component: TabsPlaceholderComponent,
  },
  {
    path: 'atelier-recup-detail/:projectId/:id',
    component: TabsPlaceholderComponent,
  },
  {
    path: 'klant-opdracht/:projectId/:id',
    component: TabsPlaceholderComponent,
    canActivate: [ClientCompanyGuardService],
  },
  {
    path: 'klant-opdracht/:projectId/:id/:priorityType',
    component: TabsPlaceholderComponent,
    canActivate: [ClientCompanyGuardService],
  },
  {
    path: 'klant-opdracht-verkocht-verhuurd/:projectId',
    component: TabsPlaceholderComponent,
    canActivate: [ClientCompanyGuardService],
  },
  {
    path: 'producten',
    component: ProductsComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: 'producten/plaatsingsprijs-ip-borden',
    component: SignPlacementPriceDetailComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: 'producten/:name',
    component: ProductDetailComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: 'bedrijven',
    component: CompaniesOverviewComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: 'bedrijven/create',
    component: EditCompanyComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: 'bedrijven/:id',
    component: EditCompanyComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: 'contacten',
    component: ContactsOverviewComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: 'planning',
    component: AdminPlanningContainerComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: 'stock-locaties',
    component: StockLocationsOverviewComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: 'signs-portal',
    component: SignsPortalComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: 'signs-portal/signs',
    component: SignsOverviewComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: 'signs-portal/signs/:id',
    component: SignEntryComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: 'signs-portal/titles',
    component: SignTitleAdjustmentPortalOverviewComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: 'signs-portal/phonenumbers',
    component: SignPhoneNumberAdjustmentPortalOverviewComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: 'signs-portal/stickers',
    component: SignStickerPortalOverviewComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: 'zoek-jobs',
    component: SearchSubProjectsInputComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: 'zoek-jobs-resultaat',
    component: SearchSubProjectsResultComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: 'installateur',
    component: PlacerPlanningViewComponent,
  },
  {
    path: 'installateur/:projectId/:subProjectId/:employeeId/:date/:taskId',
    component: ProjectPlacerFormComponent,
  },
  {
    path: 'installateur/laden/:employeeId/:date/:taskId',
    component: LoadTaskPlacerFormComponent,
  },
  {
    path: 'installateur/taak/:employeeId/:date/:taskId',
    component: OtherTaskPlacerFormComponent,
  },
  {
    path: 'ip-installateur',
    component: ImmoIPPlacerTourViewComponent,
  },
  {
    path: 'ip-installateur/opdracht/:dateString/:subProjectId',
    component: ImmoIPPlacerTourItemDetailComponent,
  },
  {
    path: 'ip-installateur/opdracht-andere-toer/:projectId',
    component: ImmoIPPlacerTourItemDetailComponent,
  },
  {
    path: 'ip-installateur/taak/:dateString/:immoTaskId',
    component: ImmoIPPlacerImmoTaskDetailComponent,
  },
  {
    path: 'atelier',
    component: AtelierAssignmentsViewComponent,
    data: { reviewOnly: false },
  },
  {
    path: 'atelier-sign/:id',
    component: AtelierSignComponent,
  },
  {
    path: 'atelier-controle',
    component: AtelierAssignmentsViewComponent,
    data: { reviewOnly: true },
  },
  {
    path: 'atelier-recup',
    component: AtelierRecoveryComponent,
  },
  {
    path: 'contacten/create',
    component: EditContactComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: 'contacten/:id',
    component: EditContactComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: 'users',
    component: UsersOverviewComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: 'users/employees',
    component: EmployeeUsersOverviewComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: 'users/create',
    component: EditUserComponent,
    canActivate: [AdminAuthGuardService],
  },
  { path: 'users/edit/:id', component: EditUserComponent },
  {
    path: 'users/employee-edit/:id',
    component: EditEmployeeUserComponent,
    canActivate: [AdminAuthGuardService],
  },
  { path: 'client-corner', component: ClientCornerHomePageComponent },
  { path: 'client-corner/home', component: ClientCornerHomePageComponent },
  {
    path: 'client-corner/projecten',
    component: ClientCornerMapComponent,
    canActivate: [ClientCompanyGuardService],
  }, //temporary path
  {
    path: 'client-corner/lopende',
    component: OngoingProjectsComponent,
    canActivate: [ClientCompanyGuardService],
  },
  {
    path: 'client-corner/afgehaalde',
    component: RepoProjectsComponent,
    canActivate: [ClientCompanyGuardService],
  },
  {
    path: 'client-corner/uitgevoerde',
    component: CompletedProjectsComponent,
    canActivate: [ClientCompanyGuardService],
  },
  {
    path: 'klant-opdracht-aanpassing/:projectId',
    component: TabsPlaceholderComponent,
    canActivate: [ClientCompanyGuardService],
  },
  {
    path: 'klant-opdracht-weghalen/:projectId',
    component: TabsPlaceholderComponent,
    canActivate: [ClientCompanyGuardService],
  },
  {
    path: 'config/client-portal',
    component: ClientPortalConfigComponent,
    canActivate: [AdminAuthGuardService],
  },
  { path: '**', redirectTo: '' },
];
